import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
    import { isMobile } from 'react-device-detect';
    import { Helmet } from 'react-helmet-async';
    import { Link, useSearchParams ,useNavigate, useLocation} from 'react-router-dom';
    import UseLangLstQuery from 'Apis/LangTxtInqApi';
    import useRecaptcha from 'Utils/useRecaptcha';
    import RsvdApi from 'Apis/RsvdApi';
    import "Assets/css/Preregister.css";
    import RightImageNav from 'Components/RightImageNav';
    import Slider from "react-slick";
    import { Swiper, SwiperSlide } from 'swiper/react';
    import type { Swiper as SwiperType } from 'swiper';
    import { EffectCreative, Keyboard } from 'swiper/modules';
    import "slick-carousel/slick/slick.css";
    import "slick-carousel/slick/slick-theme.css";
    import ApiError from 'Utils/ApiError';
    import TrmsCtxtUi from 'Views/Trms/TrmsCtxtUi';
    import RsvdInfoApi from 'Apis/RsvdInfoApi';
    import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
    import GameSvcRsvdAccuApi from 'Apis/GameSvcRsvdAccuApi';
    import refererApi from 'Apis/refererApi';
    import PreregisterNewsletterSection from './PreregisterNewsletterSection';
    import PreregisterFeaturesSection, { PreregisterFeaturesSectionHandle } from './PreregisterFeaturesSection';
    import GlbFtrUi from 'Views/Glb/GlbFtrUi';

// 스크롤 애니메이션: [모험의 시작] 텍스트
function useInView(threshold = 0.2): [React.RefObject<HTMLDivElement>, boolean] {
    const ref = React.useRef<HTMLDivElement>(null);
    const [inView, setInView] = React.useState(false);
    const [thumbIndex, setThumbIndex] = useState<number>(1);
    React.useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new window.IntersectionObserver(
            ([entry]) => setInView(entry.isIntersecting),
            { threshold }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [threshold]);
    return [ref, inView];
}

// --- 범용 Alert 모달 컴포넌트 ---
function AlertModal({ open, message, onClose }: { open: boolean; message: string; onClose: () => void }) {
    if (!open) return null;
    return (
        <div className="preregister-modal-overlay">
            <div className="preregister-modal alert">
                <div className="modal-content alert">
                    <p>{message}</p>
                </div>
                <div className="modal-footer alert">
                    <button className="modal-confirm-btn" onClick={onClose}>확인</button>
                </div>
            </div>
        </div>
    );
}

// --- 모달 컴포넌트 ---
function MarketingModal({ open, onClose }: { open: boolean; onClose: () => void }) {
    if (!open) return null;
    return (
        <div className="preregister-modal-overlay">
            <div className="preregister-modal">
                <div className="modal-header">
                    <h3>광고성 정보 수신 동의 안내</h3>
                    <button className="trmsMdalCloseBtn" onClick={onClose}>
                        <i className="close"></i>
                    </button>
                </div>
                <div className="modal-content">
                    <p>
                        무브인터렉티브에서 제공하는<br /> 베어브릭 히어로즈 이벤트 안내 등의<br />
                        광고성 정보 내용을 SMS/LMS, E-Mail로 알려드립니다. <br />동의 거부 시 안내가 불가합니다.<br />
                        <br />
                        - 개인정보 수집 및 이용 목적 : 무브인터렉티브에서 진행하는 이벤트 및 게임 정보 안내 등 광고성 정보 안내<br />
                        - 수집 개인정보 항목 : 휴대전화번호, 이메일 주소<br />
                        - 개인정보 보유 및 이용기간 : 수신 동의 후 1년
                    </p>
                </div>
                <div className="modal-footer">
                    <button className="modal-confirm-btn" onClick={onClose}>확인</button>
                </div>
            </div>
        </div>
    );
}

// --- 개인정보 모달 컴포넌트 ---
function PrivacyModal({ open, onClose }: { open: boolean; onClose: () => void }) {
    if (!open) return null;
    return (
        <div className="preregister-modal-overlay">
            <div className="preregister-modal">
                <div className="modal-header">
                    <h3>개인정보 수집·이용 동의 안내</h3>
                    <button className="trmsMdalCloseBtn" onClick={onClose}>
                        <i className="close"></i>
                    </button>
                </div>
                <div className="modal-content">
                    <p>
                       무브인터렉티브는 게임 및 이벤트 정보 전송을 위해 개인정보를 수집 및 이용하고 있습니다.<br />
                        <br />
                        귀하는 개인정보 수집 이용에 동의하지 않을 수 있으며, <br />동의 거부 시 이벤트에 참여가 불가합니다.<br />
                        <br />
                        - 개인정보의 수집 및 이용 목적 : 사전예약 및 이벤트 참여,혜택 지급,고객문의 대응<br />
                        - 수집하는 개인정보의 항목 : 휴대전화번호<br />
                        - 개인정보의 보유 및 이용 기간 : 수집일로부터 1년
                    </p>
                </div>
                <div className="modal-footer">
                    <button className="modal-confirm-btn" onClick={onClose}>확인</button>
                </div>
            </div>
        </div>
    );
}

// --- 제3자 제공 및 국외 이전 모달 컴포넌트 ---
function ThirdPartyModal({ open, onClose }: { open: boolean; onClose: () => void }) {
    if (!open) return null;
    return (
        <div className="preregister-modal-overlay">
            <div className="preregister-modal">
                <div className="modal-header">
                    <h3>개인정보의 제3자 제공 및 국외 이전 동의</h3>
                    <button className="trmsMdalCloseBtn" onClick={onClose}>
                        <i className="close"></i>
                    </button>
                </div>
                <div className="modal-content">
                    <p>
                        (주)무브인터렉티브의 사업운영, 제품 및 서비스의 제공 및 개선, 사용자에 대한 안내, 효과적인 광고 개발 등에 이용하고자 이용자의 개인정보 일부 또는 전부를 아래의 해외 업체에 이전할 수 있습니다.<br />
                        용자는 동의를 거부하실 권리가 있으나 상기 업체는 웹사이트 및 게임 서비스 제공을 위한 필수적인 업체로서 동의 거부 시 웹사이트 및 게임 서비스의 이용이 불가 합니다. <br />
                        <br />
                        수탁자(이전 받는 자): Microsoft Corporation<br />
                        이전 되는 개인정보 항목: 계정명, 계정 비밀번호, 생년월일, 성명, 이메일 주소, 쿠키, IP주소, 중복가입확인정보, PC 하드웨어 정보, 법정대리인에 관한 정보(성명, 이메일 주소, 중복가입확인정보)<br />
                        이전 되는 국가: Microsoft Privacy, Microsoft Corporation, One Microsoft Way, Redmond, Washington 98052, United States <br />
                        이전 일시 및 이전 방법: 서비스 이용 시 네트워크를 통한 실시간 전송 <br />
                        이전 받는 자의 성명 및 연락처: Microsoft Corporation / (+1) 425-882-8080<br />
                        개인정보 이용 목적: 온라인 게임 서비스 운영 및 관련 사업 제공<br />
                        보유 기간: 사용자의 회원 탈퇴 및 서비스 계약 종료 시까지
                    </p>
                </div>
                <div className="modal-footer">
                    <button className="modal-confirm-btn" onClick={onClose}>확인</button>
                </div>
            </div>
        </div>
    );
}

// --- fbq 타입 선언 (메타픽셀)
declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}

type RsvdInfo = {
    rsvdYn: 'Y' | 'N';
    rsvdStrtDtime: string;
    rsvdStopDtime: string;
    preRlsStrtDtime: string;
    preRlsStopDtime: string;
};

const PreregisterGoUi = () => {
        // iOS/모바일+세로모드 조건을 상태로 관리
        const navigate = useNavigate();
        const getIsIOS = () => (
            /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document)
        ) && !(window as any).MSStream;
        const getIsMobileViewport = () => window.matchMedia('(max-width: 768px)').matches;
        const getIsSectionStackViewport = () => window.matchMedia('(max-width: 1024px)').matches;
        const getIsMobileDevice = () => isMobile || getIsIOS() || getIsMobileViewport();
        const getIsPortrait = () => window.matchMedia('(orientation: portrait)').matches;
        const [isMobileDevice, setIsMobileDevice] = useState(getIsMobileDevice());
        const [isSectionStackMode, setIsSectionStackMode] = useState(getIsSectionStackViewport());
        const [isPortrait, setIsPortrait] = useState(getIsPortrait());
        const [rsvdState, setRsvdState] = useState<string>("N");
        const [sectionViewState, setSectionViewState] = useState<'preLogin' | 'success' | null>(null);
        const { push: gtmPush } = useGtm();
        const sectionControllerRef = useRef<any>(null);
        const featureSectionHandleRef = useRef<PreregisterFeaturesSectionHandle | null>(null);
        const isSectionSlideChangingRef = useRef(false);
        const sectionUnlockTimerRef = useRef<number | null>(null);

        useEffect(() => {
            refererApi().then((resp) => {}).catch((err) => {});
            GameSvcRsvdAccuApi('BBO').then(async (resp) => {
                switch (resp.apiHdr.code) {
                    case "ATHN2303" :
                        setSectionViewState('preLogin');
                    break;
                    case "GAME0000":
                        setRsvdState('Y');
                        setSectionViewState('success');
                        setAlertModalMessage('사전예약이 완료되었습니다.');
                        alertOnCloseRef.current = () => {};
                        setAlertModalOpen(true);
                        if (window.fbq) window.fbq('trackCustom', 'kbbo_fb_Register_Start');
                        const tsKst = getKstTimestamp();
                        const adPayload = await fetchAdPayload( 'BBO');
                        gtmPush(`BBO_GA_PreRegister_Complete`, {
                            ts: tsKst,
                            ...adPayload,
                        });
                    break;
                    case "GAME3120":
                        setRsvdState('Y');
                        setSectionViewState('success');
                    break;
                    default:
                        setSectionViewState('preLogin');
                    break;
                }
            }).catch((err) => {
                setSectionViewState('preLogin');
            });

            const handleResize = () => {
                setIsMobileDevice(getIsMobileDevice());
                setIsSectionStackMode(getIsSectionStackViewport());
                setIsPortrait(getIsPortrait());
            };
            window.addEventListener('resize', handleResize);
            window.addEventListener('orientationchange', handleResize);
            document.addEventListener('visibilitychange', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
                window.removeEventListener('orientationchange', handleResize);
                document.removeEventListener('visibilitychange', handleResize);
            };
            
        }, []);
    // Meta Pixel: 페이지 뷰 이벤트
    const [rsvdInfoState, setRsvdInfoState] = useState<RsvdInfo | null>(null);
    const [rsvdInfoLoaded, setRsvdInfoLoaded] = useState(false);
    useEffect(() => {
        if (window.fbq) {
            window.fbq('trackCustom', 'bbo_fb_PageView');
        }
        gtmPush('page_view', { page: 'preregister' });
        RsvdInfoApi("bbo")
            .then((resp) => {
                switch (resp.apiHdr.code) {
                    case "GAME0000":
                        setRsvdInfoState(resp.apiBody);
                        break;
                    case "GAME3116":
                        setRsvdInfoState(null);
                    break;
                    default:
                        ApiError(langData, resp.apiHdr.code);
                        break;
                }
            })
            .finally(() => setRsvdInfoLoaded(true));
    }, []);
    // 비디오 ref (필요시)
    const introVideoRef = useRef<HTMLVideoElement>(null);
    const heroVideoRef = useRef<HTMLVideoElement>(null);
    const mediaSliderRef = useRef<any>(null);
    // 이후 리사이즈/화면전환에서는 기존 updateSrc 로직 사용

    // 게임 서비스 코드를 URL 파라미터에서 추출
    const [searchParams] = useSearchParams();
    const gameSvcCd = searchParams.get("gameSvcCd") || "bbo"; // 예: /page?gameSvcCd=XXX, 없으면 BBO
    const { isLoading, error, data: langData }: any = UseLangLstQuery();
    const [email, setEmail] = useState("");
    const emailInputRef = useRef<HTMLInputElement>(null);
    const [phoneNumber, setPhoneNumber] = useState("");
    const phoneInputRef = useRef<HTMLInputElement>(null);
    const [agreeAge, setAgreeAge] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [agreeMarketing, setAgreeMarketing] = useState(false);
    const [agreeThirdParty, setAgreeThirdParty] = useState(false);
    const [agreeAll, setAgreeAll] = useState(false);
    // Alert modal state & callback ref
    const [alertModalOpen, setAlertModalOpen] = useState(false);
    const [alertModalMessage, setAlertModalMessage] = useState('');
    const alertOnCloseRef = useRef<() => void>(() => {});
    type SoundKey = 'complete' | 'dragClick' | 'click' | 'rightMenuSelect' |'hover';
    const soundRefs = useRef<Record<SoundKey, HTMLAudioElement | null>>({
        complete: null,
        dragClick: null,
        click: null,
        rightMenuSelect: null,
        hover: null,
    });

    const openAlert = (msg: string, onClose?: () => void) => {
        setAlertModalMessage(msg);
        alertOnCloseRef.current = onClose || (() => {});
        setAlertModalOpen(true);
    };

    const playButtonSound = (key: SoundKey = 'click') => {
        const audio = soundRefs.current[key];
        if (audio) {
            audio.currentTime = 0;
            audio.play().catch(() => {});
        }
    };

    const { getToken } = useRecaptcha();
    // thumbnail index used by copied start/article block
    const [thumbIndex, setThumbIndex] = useState<number>(1);

    const handleStart = useCallback(() => {
        playButtonSound('click');
        try {
            const mbtiUrl = `${window.location.origin}/bb4me?referrer=preregister`;
            window.open(mbtiUrl, '_blank', 'noopener,noreferrer');
            return;
        } catch (e) {
            // If popup blocked or any error, fallback to in-page scroll
        }
        const target = document.querySelector('.preregisterContainer.form-section') as HTMLElement | null;
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            // fallback: scroll to top
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, []);

    // If navigated with a hash (e.g. /preregister?gameSvcCd=KBBO#formSec), scroll to that element.
    const location = useLocation();
    useEffect(() => {
        try {
            if (!location || !location.hash) return;
            const id = location.hash.replace('#', '');
            let target: HTMLElement | null = null;
            if (id) {
                target = document.getElementById(id);
            }
            // fallbacks if element not found
            if (!target) {
                target = document.querySelector('#formSec') as HTMLElement | null;
            }
            if (!target) {
                target = document.querySelector('.preregisterContainer') as HTMLElement | null;
            }
            if (!target) {
                target = document.querySelector('.form-section') as HTMLElement | null;
            }
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } catch (e) {
            // ignore
        }
    }, [location]);

    // Thumbnail 애니메이션 - 컴포넌트 마운트 시에만 한 번 설정
    useEffect(() => {
        const id = setInterval(() => {
            setThumbIndex(prev => (prev % 12) + 1);
        }, 500);
        return () => clearInterval(id);
    }, []);
    // const [autoSlideEnabled, setAutoSlideEnabled] = useState(true);
    // const [lastUserInteraction, setLastUserInteraction] = useState(0);

    
    // 마케팅 및 개인정보 모달 상태
    const [marketingModalOpen, setMarketingModalOpen] = useState(false);
    const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
    const [thirdPartyModalOpen, setThirdPartyModalOpen] = useState(false);

    // 모달 오픈 시 body 스크롤 방지
    useEffect(() => {
        const isModalOpen = marketingModalOpen || privacyModalOpen || alertModalOpen || thirdPartyModalOpen;
        if (isModalOpen) {
            // 스크롤 막기
            document.body.style.overflow = 'hidden';
        } else {
            // 스크롤 허용
            document.body.style.overflow = '';
        }
        // 언마운트 시 복구
        return () => {
            document.body.style.overflow = '';
        };
    }, [marketingModalOpen, privacyModalOpen, alertModalOpen, thirdPartyModalOpen]);

    // Sticky 배경을 위한 동적 높이 계산 (이미지/폰트 지연 로드 대응)
    useEffect(() => {
        const contentSections = document.querySelector('.content-sections') as HTMLElement | null;
        const stickyWrap = document.querySelector('.stickyBgWrap') as HTMLElement | null;

        if (!contentSections || !stickyWrap) return;

        const updateStickyHeight = () => {
            stickyWrap.style.height = contentSections.scrollHeight + 'px';
        };

        const rafUpdate = () => requestAnimationFrame(updateStickyHeight);

        // 초기 계산 + 리사이즈/폰트 로드 대응
        rafUpdate();
        const handleResize = () => rafUpdate();
        window.addEventListener('resize', handleResize);
        document.fonts.ready.then(rafUpdate);

        // 이미지 로드 완료 시 재계산 (느리게 로드되는 경우 보정)
        const imgs = Array.from(contentSections.querySelectorAll('img'));
        const imgListeners = imgs
            .filter(img => !img.complete)
            .map(img => {
                const onLoad = () => rafUpdate();
                img.addEventListener('load', onLoad);
                img.addEventListener('error', onLoad);
                return { img, onLoad };
            });

        // 콘텐츠 높이 변화를 관찰 (텍스트 줄바꿈 등)
        let resizeObserver: ResizeObserver | null = null;
        if ('ResizeObserver' in window) {
            resizeObserver = new ResizeObserver(() => rafUpdate());
            resizeObserver.observe(contentSections);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
            imgListeners.forEach(({ img, onLoad }) => {
                img.removeEventListener('load', onLoad);
                img.removeEventListener('error', onLoad);
            });
            resizeObserver?.disconnect();
        };
    }, [email, phoneNumber, agreeTerms, agreeMarketing]); // 폼 상태 변경 시에도 재계산

    const sectionNavItems = useMemo(() => [
        { id: 'hero', label: '메인', selector: '#heroSec' },
        { id: 'event', label: '이벤트', selector: '#eventSec' },
        { id: 'features', label: '게임 소개', selector: '#featuresSec' },
    ], []);

    const SECTION_SLIDE_DURATION_MS = 560;
    const SECTION_FADE_MIN_OPACITY = 0.18;
    const WHEEL_TRIGGER_DELTA = 26;
    const [activeSection, setActiveSection] = React.useState<string | null>(sectionNavItems[0]?.id ?? null);
    const [isFooterOverlayOpen, setIsFooterOverlayOpen] = useState(false);

    const shouldIgnoreScrollInputTarget = useCallback((target: EventTarget | null) => {
        if (!(target instanceof HTMLElement)) return false;

        return Boolean(
            target.closest('.season2-bottom-nav') ||
            target.closest('.preregister-modal-overlay') ||
            target.closest('input, textarea, select, button')
        );
    }, []);

    const moveToSectionById = useCallback((sectionId: string) => {
        if (isSectionSlideChangingRef.current) return;

        if (sectionId !== 'features') {
            setIsFooterOverlayOpen(false);
        }

        if (sectionId === 'features' && isFooterOverlayOpen) {
            setIsFooterOverlayOpen(false);
        }

        const targetIndex = sectionNavItems.findIndex(item => item.id === sectionId);
        if (targetIndex < 0) return;

        if (isSectionStackMode) {
            const target = document.querySelector(sectionNavItems[targetIndex].selector) as HTMLElement | null;
            target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        if (sectionControllerRef.current && typeof sectionControllerRef.current.slideTo === 'function') {
            sectionControllerRef.current.slideTo(targetIndex);
            return;
        }

        const target = document.querySelector(sectionNavItems[targetIndex].selector) as HTMLElement | null;
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, [isFooterOverlayOpen, isSectionStackMode, sectionNavItems]);

    const moveSectionByDelta = useCallback((delta: number) => {
        if (activeSection === 'features') {
            if (delta > 0) {
                setIsFooterOverlayOpen(true);
                return;
            }

            if (delta < 0 && isFooterOverlayOpen) {
                setIsFooterOverlayOpen(false);
                return;
            }
        }

        const swiper = sectionControllerRef.current as SwiperType | null;
        const currentIndex = swiper && !swiper.destroyed
            ? swiper.activeIndex
            : sectionNavItems.findIndex(item => item.id === activeSection);
        if (currentIndex < 0) return;

        const slideCount = swiper && !swiper.destroyed ? swiper.slides.length : sectionNavItems.length;
        const nextIndex = Math.max(0, Math.min(slideCount - 1, currentIndex + delta));
        if (nextIndex === currentIndex) return;

        if (swiper && !swiper.destroyed) {
            swiper.slideTo(nextIndex);
            return;
        }

        if (sectionNavItems[nextIndex]) {
            moveToSectionById(sectionNavItems[nextIndex].id);
        }
    }, [activeSection, isFooterOverlayOpen, moveToSectionById, sectionNavItems]);

    const tryHandleFeatureHorizontalWheel = useCallback((deltaY: number, target: EventTarget | null) => {
        if (activeSection !== 'features') return false;
        if (isSectionSlideChangingRef.current) return false;

        if (isFooterOverlayOpen) {
            if (deltaY < 0) {
                setIsFooterOverlayOpen(false);
            }
            return true;
        }

        if (deltaY > 0 && featureSectionHandleRef.current?.isAtLastSlide()) {
            setIsFooterOverlayOpen(true);
            return true;
        }

        const swiper = sectionControllerRef.current as SwiperType | null;
        if (swiper && !swiper.destroyed) {
            const featuresIndex = sectionNavItems.findIndex(item => item.id === 'features');
            if (featuresIndex >= 0 && swiper.activeIndex !== featuresIndex) return false;
        }

        return featureSectionHandleRef.current?.handleWheel(deltaY, target) ?? false;
    }, [activeSection, isFooterOverlayOpen, sectionNavItems]);

    useEffect(() => {
        if (isSectionStackMode) return;

        const goByDelta = (delta: number) => {
            if (isSectionSlideChangingRef.current) return;

            if (isFooterOverlayOpen) {
                if (delta < 0) {
                    setIsFooterOverlayOpen(false);
                }
                return;
            }

            const swiper = sectionControllerRef.current as SwiperType | null;
            if (!swiper) return;

            const currentIndex = swiper.activeIndex;
            const slideCount = swiper.slides.length;
            const nextIndex = Math.max(0, Math.min(slideCount - 1, currentIndex + delta));
            if (nextIndex === currentIndex) return;

            swiper.slideTo(nextIndex);
        };

        const onWheel = (event: WheelEvent) => {
            if (shouldIgnoreScrollInputTarget(event.target)) return;
            event.preventDefault();

            if (isSectionSlideChangingRef.current) return;

            if (Math.abs(event.deltaY) < WHEEL_TRIGGER_DELTA) return;

            if (activeSection === 'features') {
                // features 섹션에서는 휠 입력을 가로 슬라이드 전용으로 소비한다.
                tryHandleFeatureHorizontalWheel(event.deltaY, event.target);
                return;
            }

            if (tryHandleFeatureHorizontalWheel(event.deltaY, event.target)) return;

            goByDelta(event.deltaY > 0 ? 1 : -1);
        };

        const onKeyDown = (event: KeyboardEvent) => {
            if (shouldIgnoreScrollInputTarget(event.target)) return;

            if (isFooterOverlayOpen) {
                if (event.key === 'ArrowUp' || event.key === 'PageUp') {
                    event.preventDefault();
                    setIsFooterOverlayOpen(false);
                    return;
                }

                if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key === ' ') {
                    event.preventDefault();
                    return;
                }
            }

            if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key === ' ') {
                event.preventDefault();
                goByDelta(1);
                return;
            }

            if (event.key === 'ArrowUp' || event.key === 'PageUp') {
                event.preventDefault();
                goByDelta(-1);
                return;
            }

            if (event.key === 'Home') {
                event.preventDefault();
                moveToSectionById(sectionNavItems[0].id);
                return;
            }

            if (event.key === 'End') {
                event.preventDefault();
                moveToSectionById(sectionNavItems[sectionNavItems.length - 1].id);
            }
        };

        window.addEventListener('wheel', onWheel, { passive: false });
        window.addEventListener('keydown', onKeyDown);

        return () => {
            window.removeEventListener('wheel', onWheel);
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [
        activeSection,
        WHEEL_TRIGGER_DELTA,
        isFooterOverlayOpen,
        isSectionStackMode,
        moveToSectionById,
        sectionNavItems,
        shouldIgnoreScrollInputTarget,
        tryHandleFeatureHorizontalWheel,
    ]);

    useEffect(() => {
        if (isSectionStackMode) return;

        const swiper = sectionControllerRef.current as SwiperType | null;
        if (!swiper) return;

        return () => {
            if (sectionUnlockTimerRef.current != null) {
                window.clearTimeout(sectionUnlockTimerRef.current);
            }
        };
    }, [isSectionStackMode]);

    useEffect(() => {
        if (!isSectionStackMode) return;

        const swiper = sectionControllerRef.current as SwiperType | null;
        if (swiper && !swiper.destroyed) {
            swiper.destroy(false, true);
            sectionControllerRef.current = null;
        }
    }, [isSectionStackMode]);

    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        html.style.overflow = !isSectionStackMode ? 'hidden' : '';
        body.style.overflow = !isSectionStackMode ? 'hidden' : '';

        return () => {
            html.style.overflow = '';
            body.style.overflow = '';
            if (sectionUnlockTimerRef.current != null) {
                window.clearTimeout(sectionUnlockTimerRef.current);
            }
        };
    }, [isSectionStackMode]);

    // Sticky 배경 마스크 스크롤 애니메이션 - game-features 기준
    useEffect(() => {
        let ticking = false;
        
        const handleMaskScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    const stickyBg = document.querySelector('.stickyBg') as HTMLElement;
                    const gameFeatures = document.querySelector('.newsletter-section') as HTMLElement;
                    
                    if (!stickyBg || !gameFeatures) return;
                    
                    const windowHeight = window.innerHeight;
                    const gameFeaturesRect = gameFeatures.getBoundingClientRect();
                    const gameFeaturesHeight = gameFeatures.offsetHeight;
                    
                    // game-features 섹션의 위치에 따른 진행률 계산
                    const sectionTop = gameFeaturesRect.top;
                    
                    let progress = 0;
                    
                    if (sectionTop <= 0) {
                        // 섹션이 화면 상단에 도달하거나 지나간 경우 - 최대 투명도
                        progress = 1;
                    } else {
                        // 섹션이 아직 화면 위에 있는 경우 - 거리에 따라 투명도 계산
                        const maxDistance = windowHeight * 0.7; // 화면 높이의 70% 지점부터 작동
                        const currentDistance = Math.min(sectionTop, maxDistance);
                        progress = 1 - (currentDistance / maxDistance); // 가까워질수록 1에 가까워짐
                    }
                    
                    // 마스크 진행률 계산 (0에서 1까지)
                    const maskProgress = progress; // 0 = 마스크 없음(원본 보임), 1 = 최종 마스크 적용
                    
                    // CSS 변수 업데이트 - 마스크 진행률 조절
                    stickyBg.style.setProperty('--mask-progress', maskProgress.toString());
                    
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleMaskScroll, { passive: true });
        
        // 초기 설정
        handleMaskScroll();
        
        return () => {
            window.removeEventListener('scroll', handleMaskScroll);
        };
    }, []);

    

    const [introRef, introInView] = useInView(0.2);
    const [startRef, startInView] = useInView(0.35);


    // react-slick 커스텀 화살표 및 설정
    const getSettings = (
        prefix = '',
        hideOnMobile = false,
        onArrowClick?: () => void,
        onDotClick?: () => void
    ) => {
        const PrevArrow = (props: any) => (
            <button
                {...props}
                className={" nav-arrow nav-arrow-left" + (hideOnMobile ? " moNone" : "") + (props.className ? " " + props.className : "")}
                style={{ ...props.style, display: "block" }}
                aria-label="Previous"
                onClick={(e) => {
                    if (onArrowClick) {
                        onArrowClick();
                    }
                    if (props.onClick) {
                        props.onClick(e);
                    }
                }}
            >
                <img src={process.env.PUBLIC_URL + '/images/preregister/arrow.png'} alt="Prev" style={{transform: 'rotate(180deg)'}} />
            </button>
        );
        const NextArrow = (props: any) => (
            <button
                {...props}
                className={" nav-arrow nav-arrow-right" + (hideOnMobile ? " moNone" : "") + (props.className ? " " + props.className : "")}
                style={{ ...props.style, display: "block" }}
                aria-label="Next"
                onClick={(e) => {
                    if (onArrowClick) {
                        onArrowClick();
                    }
                    if (props.onClick) {
                        props.onClick(e);
                    }
                }}
            >
                <img src={process.env.PUBLIC_URL + '/images/preregister/arrow.png'} alt="Next" />
            </button>
        );

        return {
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            // create unique arrow elements per slider to avoid shared DOM flicker
            prevArrow: <PrevArrow key={`prev-${prefix}`} />,
            nextArrow: <NextArrow key={`next-${prefix}`} />,
            customPaging: (i: number) => (
                <div
                    className="progress-bar"
                    onClick={() => {
                        if (onDotClick) {
                            onDotClick();
                        }
                    }}
                />
            ),
            appendDots: (dots: React.ReactNode) => {
                if (!onDotClick) {
                    return <div className="progress-indicators">{dots}</div>;
                }
                
                const dotsArray = React.Children.toArray(dots);
                const enhancedDots = dotsArray.map((dot) => {
                    if (React.isValidElement(dot)) {
                        return React.cloneElement(dot, {
                            onClick: (e: React.MouseEvent) => {
                                onDotClick();
                                if (dot.props.onClick) {
                                    dot.props.onClick(e);
                                }
                            }
                        } as any);
                    }
                    return dot;
                });
                
                return <div className="progress-indicators">{enhancedDots}</div>;
            },
        };
    };

    // Memoize settings per slider so props (arrow elements) are stable across renders
    // eventSettings: autoplay every 4000ms and pause when user hovers (arrows visible)
    const eventSettings = useMemo(() => ({
        ...getSettings('event', false, () => playButtonSound('dragClick'), () => playButtonSound('dragClick')),
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
    }), []);
    // mediaSettings: arrows hidden on mobile (hideOnMobile=true because external mobile buttons exist)
    const mediaSettings = useMemo(() => (
        getSettings('media', true, () => playButtonSound('dragClick'), () => playButtonSound('dragClick'))
    ), []);

    // newsletter-section으로 부드럽게 스크롤 이동
    const handleScrollToNewsletterSection = () => {
        playButtonSound();
        const section = document.querySelector('.newsletter-section');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // PC 환경에서만 호버 사운드 재생
    const handleButtonHover = () => {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (!isMobile) {
            playButtonSound('hover');
        }
    };
    const handleScrollToMbtiSection = () => {
        const section = document.querySelector('.gameMbtiSec');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
        <>
            <Helmet>
                <title>{`BE@RBRICK HEROES`}</title>
            </Helmet>
            <div className="section-main-layout">
            <div className="video-overlay hero-fixed-bg" aria-hidden>
                <img src={process.env.PUBLIC_URL + '/images/evnt/grandopen/mainBg.jpg'} alt="heroBg" />
                <div className="heroOpacityBg"></div>
            </div>
            {/* Right-side section nav (in-page) */}
            <RightImageNav
                items={sectionNavItems}
                activeId={activeSection}
                onPlaySound={() => playButtonSound('rightMenuSelect')}
                onHoverSound={handleButtonHover}
                moveToSectionById={moveToSectionById}
            />
            <Swiper
                className="section-main-swiper"
                modules={[Keyboard, EffectCreative]}
                direction="vertical"
                slidesPerView={1}
                enabled={!isSectionStackMode}
                allowTouchMove={!isSectionStackMode}
                watchSlidesProgress={!isSectionStackMode}
                speed={SECTION_SLIDE_DURATION_MS}
                effect={isSectionStackMode ? 'slide' : 'creative'}
                creativeEffect={isSectionStackMode ? undefined : {
                    limitProgress: 2,
                    prev: {
                        translate: [0, '-46%', 0],
                        scale: 0.96,
                        opacity: 0,
                    },
                    next: {
                        translate: [0, '104%', 0],
                        opacity: 1,
                    },
                }}
                keyboard={{ enabled: !isSectionStackMode, onlyInViewport: true }}
                onSwiper={(swiper: SwiperType) => {
                    if (isSectionStackMode) {
                        swiper.destroy(false, true);
                        sectionControllerRef.current = null;
                        setActiveSection(sectionNavItems[0]?.id ?? null);
                        return;
                    }

                    sectionControllerRef.current = swiper;
                    swiper.slideTo(0, 0);
                    setActiveSection(sectionNavItems[0]?.id ?? null);
                }}
                onSlideChangeTransitionStart={() => {
                    isSectionSlideChangingRef.current = true;
                }}
                onProgress={(swiper: SwiperType) => {
                    if (isSectionStackMode) return;

                    swiper.slides.forEach((slideEl: any) => {
                        const progress = Math.max(-1, Math.min(1, Number(slideEl.progress ?? 0)));
                        const opacity = Math.max(SECTION_FADE_MIN_OPACITY, 1 - Math.abs(progress) * 0.82);
                        slideEl.style.opacity = String(opacity);
                    });
                }}
                onSetTransition={(swiper: SwiperType, duration: number) => {
                    if (isSectionStackMode) return;

                    swiper.slides.forEach((slideEl: any) => {
                        slideEl.style.transitionProperty = 'transform, opacity';
                        slideEl.style.transitionDuration = `${duration}ms`;
                    });
                }}
                onSlideChange={(swiper: SwiperType) => {
                    const next = sectionNavItems[swiper.activeIndex];
                    setActiveSection(next ? next.id : null);

                    if (next?.id !== 'features') {
                        setIsFooterOverlayOpen(false);
                    }
                }}
                onSlideChangeTransitionEnd={() => {
                    if (sectionUnlockTimerRef.current != null) {
                        window.clearTimeout(sectionUnlockTimerRef.current);
                    }

                    sectionUnlockTimerRef.current = window.setTimeout(() => {
                        isSectionSlideChangingRef.current = false;
                    }, SECTION_SLIDE_DURATION_MS + 40);
                }}
            >
                <SwiperSlide>
                {/* Hero Section */}
                <div className="hero-section" id="heroSec">
                    <div className="hero-content">
                        {/* Newsletter Section */}
                        {sectionViewState && (
                            <PreregisterNewsletterSection
                                viewState={sectionViewState}
                                onLoginClick={() => playButtonSound('click')}
                            />
                        )}
                        
                    </div>

                    <img src={process.env.PUBLIC_URL + '/images/preregister/scrollicon.png'} alt="scrollIcon"  className='scrollIcon'/>
                </div>
                </SwiperSlide>
                <SwiperSlide>
                    {/* Event Section */}
                    <div className="goEvntSec" id="eventSec">
                        
                        <h2 className="section-title">사전예약 이벤트</h2>
                        <ul className="rewardUl">
                            <li>
                                <h3>1. 사전예약 한정 특별 보상</h3>
                                <p>Grand Open 기념 사전예약 유저를 위한 선물</p>
                                <img
                                    src={(isMobileDevice ? 'https://bb-cdn.gameking.com/web/event/grandopen/eventReward01_mo.png' : 'https://bb-cdn.gameking.com/web/event/grandopen/eventReward01.png')}
                                    alt="event reward"
                                />
                            </li>
                            <li>
                                <h3>2. OBT 참여 이벤트</h3>
                                <p>정식 오픈 전 BE@RBRICK HEROES 사전플레이 보상</p>
                                <img
                                    src={isMobileDevice ? 'https://bb-cdn.gameking.com/web/event/grandopen/eventReward02_mo.png' : 'https://bb-cdn.gameking.com/web/event/grandopen/eventReward02.png'}
                                    alt="event reward"
                                />
                            </li>
                        </ul>
                        <div className="eventDescWrap">
                            <ul className="eventDescUl">
                                <li>
                                    <ul>
                                        <li>
                                            <p>※ 본 페이지에 게재된 이미지 및 영상은 개발 중인 버전으로 , 실제 서비스 내용과 다를 수 있습니다 .</p>
                                        </li>
                                        <li>
                                            <p>※ 본 이벤트는 당사 사정에 따라 사전 고지 없이 내용이 변경되거나 조기 종료될 수 있으며 , 변경 사항은 별도 공지를 통해 안내해 드립니다 .</p>
                                        </li>
                                        <li>
                                            <p>※ 사전예약 보상은 계정당 최초 1회에 한하여 지급됩니다. </p>
                                        </li>
                                        <li>
                                            <p>※ 사전예약 보상은 그랜드 오픈 이후 게임 내 우편함을 통해 지급됩니다. </p>
                                        </li>
                                        <li>
                                            <p>※ 사전예약 기간 내 회원가입 후 회원 탈퇴를 진행한 경우, 사전예약 보상 지급 대상에서 제외되며 보상 제공이 불가능합니다.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <ul>
                                        <li>
                                            <p>※ 사전예약 참여 후 휴대폰 번호 변경 또는 정보 오기재 등으로 인해 보상을 수령하지 못한 경우,당사에서 별도 지원이 어려울 수 있습니다.</p>
                                        </li>
                                        <li>
                                            <p>※ 그랜드 오픈 전 OBT 데이터는 초기화될 예정입니다.</p>
                                        </li>
                                        <li>
                                            <p>※ OBT 참여 보상은 이벤트 조건 및 미션을 달성한 계정에 한하여 그랜드 오픈 이후 지급됩니다.</p>
                                        </li>
                                        <li>
                                            <p>※ 이벤트 관련 상세 안내 및 문의는 공식 커뮤니티 또는 고객센터를 이용해 주시기 바랍니다.</p>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="section-slide-shell">
                        <div className="section-slide-content">
                        <PreregisterFeaturesSection
                            ref={featureSectionHandleRef}
                            isMobileDevice={isMobileDevice}
                            isActive={activeSection === 'features'}
                            onMoveSectionByDelta={moveSectionByDelta}
                            onReachBeyondLast={() => setIsFooterOverlayOpen(true)}
                        />
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
            <div className={`footer-overlay-layer${isFooterOverlayOpen ? ' is-open' : ''}`}>
                <div className="footer-overlay-panel">
                    <GlbFtrUi gameSvcCd={gameSvcCd}/>
                </div>
            </div>
            </div>


            {/* ReCaptcha */}
            {/* reCAPTCHA provided at app root; per-page provider removed */}

            {/* Modals */}
            <MarketingModal open={marketingModalOpen} onClose={() => setMarketingModalOpen(false)} />
            <PrivacyModal open={privacyModalOpen} onClose={() => setPrivacyModalOpen(false)} />
            <ThirdPartyModal open={thirdPartyModalOpen} onClose={() => setThirdPartyModalOpen(false)} />
            <AlertModal
                open={alertModalOpen}
                message={alertModalMessage}
                onClose={() => {
                    setAlertModalOpen(false);
                    try { alertOnCloseRef.current(); } catch (e) {}
                }}
            />

                        {/* Audio for button feedback */}
            <audio ref={(el) => { soundRefs.current.complete = el; }} preload="auto" style={{ display: 'none' }}>
                <source src={process.env.PUBLIC_URL + '/audio/ui_complete.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.dragClick = el; }} preload="auto" style={{ display: 'none' }}>
                <source src={process.env.PUBLIC_URL + '/audio/ui_drag_click.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.click = el; }} preload="auto" style={{ display: 'none' }}>
                <source src={process.env.PUBLIC_URL + '/audio/ui_click.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.hover = el; }} preload="auto" style={{ display: 'none' }}>
                <source src={process.env.PUBLIC_URL + '/audio/ui_hover.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.rightMenuSelect = el; }} preload="auto" style={{ display: 'none' }}>
                <source src={process.env.PUBLIC_URL + '/audio/ui_right_menu_select.wav'} type="audio/wav" />
            </audio>

        </>
    );
};

export default PreregisterGoUi;